import { useEffect, useMemo, useRef, useState } from 'react'
import { css } from '@firebolt-dev/css'

import { cls } from '../core/cls'

import { UICodeEditor } from './UICodeEditor'
import { UIEditorFieldText } from './UIEditorFieldText'

export function UIEditorScriptPane({ client, tab, editTab, visible, showModal }) {
  const [id, setID] = useState(tab.data.asset.id)
  const [code, setCode] = useState(tab.data.asset.code)

  const dataRef = useRef({})
  dataRef.current.id = id
  dataRef.current.code = code

  useEffect(() => {
    editTab(t => {
      t.icon = 'script'
      t.label = id
    })
  }, [id])

  const initRef = useRef()
  useEffect(() => {
    if (tab.save) return
    if (!initRef.current) {
      initRef.current = true
      return
    }
    const save = async () => {
      const ops = { remove: [], upsert: [] }
      const registry = client.registry
      const isNew = tab.data.isNew

      const { id, code } = dataRef.current
      const asset = {
        id,
        type: 'script',
        code,
      }

      // if this is a new asset OR the asset changed its id, ensure the id is available
      if (isNew || (!isNew && tab.data.asset.id !== asset.id)) {
        const taken = !!registry.raw.find(a => a.type === asset.type && a.id === asset.id)
        if (taken) {
          await showModal({
            title: 'Duplicate ID',
            message: `An asset with the ID '${asset.id}' already exists.`,
            btns: [
              {
                label: 'Okay',
                action: null,
              },
            ],
          })
          return false
        }
      }
      // if updating and id changed, delete old asset
      if (!isNew && tab.data.asset.id !== asset.id) {
        ops.remove.push({ type: tab.data.asset.type, id: tab.data.asset.id })
        // delete rootStore.assets[_tab.asset.id]
        // await deleteFile(rootStore.dir, `/${_tab.asset.type}s/${_tab.asset.id}.json`)
      }
      ops.upsert.push(asset)

      client.network.send('editAssets', ops)

      editTab(t => {
        t.data.asset = asset
        t.data.isNew = false
        t.save = null
      })
    }
    editTab(t => {
      t.save = save
    })
  }, [id, code])

  return (
    <div
      className='script'
      css={css`
        pointer-events: auto;
        flex: 1;
        position: relative;
        border-top: 6px solid var(--bg3);
        background: var(--bg1);
        display: flex;
        flex-direction: column;
        .script-id {
          padding: 10px;
          border-bottom: 1px solid var(--bg3);
        }
        .script-editor {
          flex: 1;
          position: relative;
          > * {
            position: absolute;
            inset: 0;
          }
          .editor-mount {
            padding-top: 10px;
          }
        }
      `}
    >
      <div className='script-id'>
        <UIEditorFieldText value={id} onChange={setID} />
      </div>
      <div className='script-editor'>
        <UICodeEditor value={code} onChange={setCode} />
      </div>
    </div>
  )
}
